import React from 'react'
import PropTypes from 'prop-types'
import '../assets/css/components/confirmation-popup.css'
import LoadingAnimation from '../assets/img/loading-pinwheel.gif'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

library.add(faCheckCircle,faExclamationCircle)

// Simple Popup component used to confirm actions.
const ConfirmationPopup = props => {
  const { bodyHtml, cancelText, confirmationText, title, message, errorMessage, successMessage, warningMessage, onConfirm, onCancel, isLoading,hideButton } = props

  return(
    <div className='confirmation-popup popup dialog simple-popup dialog--open'>
      <div onClick={onCancel} className='popup-background'></div>
      <div className="dialog__content">
        <div className="container-fluid">
          <div className="dialog__overview">
            {title && <h1>{title}</h1>}
            {!title && <br/>}
            <button onClick={onCancel} className="popup-close close action top-right"><i className="fa fa-times"></i></button>
            {message && <p className='message'>{message}</p>}
            {bodyHtml}
            {errorMessage && <div className='confirmation-popup-message'>
              <FontAwesomeIcon icon={faExclamationCircle} color={'#FFAD1F'} />
              <p className='error message' id='confirm-popup-error'>{errorMessage}</p>
              </div>}
            {successMessage && <div className='confirmation-popup-message'>
              <FontAwesomeIcon icon={faCheckCircle} color={'#4FCA15'} />
              <p className='success message' id='confirm-popup-success'>{successMessage}</p>
            </div>}

            {warningMessage && <div className='confirmation-popup-message'>
              <FontAwesomeIcon icon={faExclamationCircle} color={'#00C8E4'} />
              <p className='warning message' id='confirm-popup-warning'>{warningMessage}</p>
            </div>}

            {isLoading && <img className='loading-animation' src={LoadingAnimation} />}
            {!hideButton && <div className='buttons'>
              <button onClick={onConfirm} className='btn btn-lg btn-danger ok'>{confirmationText || 'Ok'}</button>
              <button onClick={onCancel} className='btn btn-lg btn-cancel cancel'>{cancelText || 'Cancel'}</button>
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
}

const { string, func, element, bool } = PropTypes
ConfirmationPopup.propTypes = {
  /*Alternative prop to message in order to include custom html*/
  bodyHtml:         element,
  /*The label used on the cancel button*/
  cancelText:       string,
  /*The label used on the confirmation button*/
  confirmationText: string,
  /*The string used for the label of the popup*/
  title:            string,
  /*A string describing the action that is being confirmed*/
  message:          string,
  /*A message that is shown when the action has resulted in an error*/
  errorMessage:     string,
  /*A message that is shown when the action has been run successfully*/
  successMessage:   string,
  /*A function run when the confirmation button is clicked*/
  onConfirm:        func,
  /*A function run when the cancel button is clicked*/
  onCancel:         func,
  /*A boolean to determine if a task is currently in processing */
  isLoading:        bool,
}


export default ConfirmationPopup
